export default "__VITE_ASSET__9389254f__"